import React from 'react'



;

const CuriorAdressInfo = ({zone,city ,governorate,country  ,zones=[]}) => {
  const curiorInfo = [
    { title: "الدولة", value: country?.name},
       { title: "المحافظة", value: governorate?.name},
    { title: "المدينة", value: city?.name },
    { title: "المنطقة ", value: zone?.name},
    { title: "المناطق المغطاه",   title: "المناطق المغطاه",
      value: zones.length
        ? zones.map((z) => z.name).join("، ")
        : "—",},  
      


    
      


    
    
  ];
  return (
    <div className="row">
      <h5 className="mb-3">  معلومات الموقع</h5>
      <div className="col-12">
        <ul className="two-columns">
          {curiorInfo.map((item, index) => (
            <li key={index}>
              <h4 className="font14 font700">{item.title}</h4>
        <p>{item.value}</p>
            </li>
            
          ))}
        </ul>
      </div>
    </div>
  );
};


export default CuriorAdressInfo